import { render, staticRenderFns } from "./add-module.vue?vue&type=template&id=95a8e8b4"
import script from "./add-module.vue?vue&type=script&lang=js"
export * from "./add-module.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports